import React, {Component} from 'react';
import {Card, Button, Header, Image, Icon} from 'semantic-ui-react';

const image = require('../../img/verification.svg');

class Welcome extends Component {
  constructor(props) {
    super(props);

    this.state = {
      display: 'none'
    };
    this.finish = this.finish.bind(this);
    this.open = this.open.bind(this);
  }

  finish(){
    this.props.finish();
  }

  open(){
    this.setState({display:'block'});
  }

  render() {
    return (
      <Card fluid style={{display:this.state.display}}>
        <Header as='h1' textAlign='center' style={{'marginTop':10, 'paddingTop':10}}>Bienvenido a Bisttros!</Header>
        <Card.Content>
            <Header as='h1' icon textAlign='center'>
                <Icon><Image centered src={image} height={260} alt='logo'/></Icon>
                <Header.Content>
                    <Header.Subheader>
                        <p>
                            Muchas gracias por preferir nuestro servicio
                        </p>
                    </Header.Subheader>
                    <p>
                        <Button primary  onClick={()=>this.finish()}>
                            IR A BISTTROS
                        </Button>
                    </p>
                </Header.Content>
            </Header>
        </Card.Content>
      </Card>
    );
  }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/components/setup/Welcome.js